module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.27a90e87.otf";